import React, { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Prompt } from "react-router-dom";

interface IProps {
  methods?: UseFormReturn<any, any>;
  action?: () => void;
  setAction: (value: React.SetStateAction<(() => void) | undefined>) => void;
}

export const NavigationBlock: React.FC<IProps> = ({ methods, action, setAction }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (methods?.formState.isDirty && !action) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = () => undefined;
    }

    if (action) {
      action();
      setAction(undefined);
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [methods?.formState.isDirty, action, setAction]);

  return <Prompt when={methods?.formState.isDirty && !action} message={t("payments.exit_prompt") as string} />;
};
